const styles = {
  paper: {
    maxWidth: '1280px',
    margin: '0 auto 50px'
  },
  section: {
    border: 'none',
    '& h3': {
      textAlign: 'center',
      width: '100%'
    }
  },
  stage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    maxWidth: '40%',
    margin: '30px auto 0'
  },
  arrow: {
    borderRadius: '100%',
    width: '50px',
    height: '50px',
    fontSize: '22px',
    display: 'flex',
    justifyContent: 'center'
  },
  avatar: {
    fontSize: '200px',
    border: '6px solid #fff',
    boxShadow: '0 0 4px 2px rgba(0,0,0,0.1)'
  },
  colors: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '30px'
  },
  color: {
    height: 'auto',
    '& > span': {
      display: 'block',
      width: '50px',
      height: '50px',
      margin: '0 5px',
      borderRadius: '100%',
      border: '4px solid #fff',
      boxShadow: '0 0 4px 2px rgba(0,0,0,0.1)',
      transition:
        'transform 200ms ease-in-out, box-shadow 200ms ease-in-out, opacity 300ms ease-in-out',
      '&:hover': {
        opacity: 0.8
      },
      '&:active': {
        transform: 'scale(0.9)',
        boxShadow: '0 0 2px 1px rgba(0,0,0,0.1)'
      }
    }
  },
  action: {
    textAlign: 'center',
    margin: '30px 0'
  }
}

export default styles
